/**
 * Extends standard "Error" object to support adding extra properties.
 */
export class ErrorExtended<T> extends Error {
    /**
     * Known extended source names.
     */
    public static sources = {
        getNoCache: 'getNoCache',
        aadSso: 'aadSso'
    };

    /**
     * The extended error source name.
     */
    public extendedSource: string;

    /**
     * The extended content.
     */
    public extended: T;
}
